import { CHART_STACKING_TYPE, CHART_TYPE, YAXIS_POSITION } from 'xangle-charts'

import { ChartInfo, TokenPriceInfo } from '~/api/repository'
import { CHAIN } from '~/constants/default.constants'

export class CTokenPriceModel {
  private readonly _price: string
  private readonly _marketCap: string
  private readonly _volume24h: string
  private readonly _totalSupply: string
  private readonly _circulatingSupply: string
  private readonly _priceChange1h: string
  private readonly _priceChange24h: string
  private readonly _priceChange7d: string
  private readonly _priceChart: Array<ChartInfo>

  constructor(param: TokenPriceInfo) {
    this._price = param.P ?? ''
    this._marketCap = param.MC ?? ''
    this._volume24h = param.VOL24H ?? ''
    this._totalSupply = param.TSUP ?? ''
    this._circulatingSupply = param.CIRSUP ?? ''
    this._priceChange1h = param.PCNG1H ?? ''
    this._priceChange24h = param.PCNG24H ?? ''
    this._priceChange7d = param.PCNG7D ?? ''
    this._priceChart = param.PCH ?? []
  }

  get price() {
    return this._price
  }

  get marketCap() {
    return this._marketCap
  }

  get volume24h() {
    return this._volume24h
  }

  get totalSupply() {
    return this._totalSupply
  }

  get circulatingSupply() {
    return this._circulatingSupply
  }

  get priceChange1h() {
    return this._priceChange1h
  }

  get priceChange24h() {
    return this._priceChange24h
  }

  get priceChange7d() {
    return this._priceChange7d
  }

  get homeTokenPriceTable() {
    return [
      {
        label: `${CHAIN} Price`,
        value: this._price,
        prefix: '$',
        useContraction: false,
      },
      {
        label: '1H Price Change',
        value: this._priceChange1h,
        unit: '%',
        useNumericStyle: true,
        useContraction: false,
      },
      {
        label: '24H Price Change',
        value: this._priceChange24h,
        unit: '%',
        useNumericStyle: true,
        useContraction: false,
      },
      {
        label: '7D Price Change',
        value: this._priceChange7d,
        unit: '%',
        useNumericStyle: true,
        useContraction: false,
      },
      {
        label: 'Market Cap',
        value: this._marketCap,
        prefix: '$',
        useContraction: false,
      },
      {
        label: 'Volume(24H)',
        value: this._volume24h,
        prefix: '$',
        useContraction: false,
      },
    ]
  }

  get chartData() {
    return [
      {
        name: 'Price',
        yAxis: YAXIS_POSITION.RIGHT,
        type: CHART_TYPE.AREA,
        stacking: CHART_STACKING_TYPE.NONE,
        unit: '$',
        decimalPoint: 2,
        data: this._priceChart?.map((ele) => {
          return {
            day: ele.TS,
            value: ele.VAL
          }
        }) ?? []
      }
    ]
    // return this._priceChart.map((item) => {
    //   return {
    //     name: 'Price',
    //     yAxis: CHART_CONSTANTS.YAXIS_POSITION.RIGHT,
    //     type: CHART_CONSTANTS.CHART_TYPE.AREA,
    //     stacking: CHART_CONSTANTS.CHART_STACKING_TYPE.NONE,
    //     unit: '',
    //     decimalPoint: 2,
    //     data: item.DATA?.map((innerEle) => {
    //       return {
    //         day: innerEle.TS,
    //         value: innerEle.VAL
    //       }
    //     }) ?? []
    //   }
    // })
  }
}